import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../components/Student/StuStyles/ApplicationForm.css";
import { toast, ToastContainer } from "react-toastify";
import ApiService from "../nhrc_apis/ApiService";

const Hrtrainapplication = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedProgram = location.state;

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName:         "",
    email:            "",
    phone:            "",
    location:         "",
    program:          selectedProgram?.title || "",
    iama:             "",
    nhrcid:           "",
    collegename:      "",
    yearofpassout:    "",
    companyname:      "",   // ✅ NEW — maps to company_name
    companylocation:  "",   // ✅ NEW — maps to company_location
    agree:            false,
  });

  const [errors, setErrors] = useState({});

  // ─── VALIDATE SINGLE FIELD ────────────────────────────────
  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "fullName":
        if (!value.trim()) {
          error = "Full name is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Full name must contain only letters and spaces.";
        } else if (value.trim().length < 3) {
          error = "Full name must be at least 3 characters.";
        }
        break;

      case "email":
        if (!value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "phone":
        if (!value.trim()) {
          error = "Phone number is required.";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Phone number must be exactly 10 digits.";
        }
        break;

      case "location":
        if (!value.trim()) {
          error = "Location is required.";
        } else if (value.trim().length < 2) {
          error = "Location must be at least 2 characters.";
        }
        break;

      case "iama":
        if (!value.trim()) {
          error = "This field is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "This field must contain only letters and spaces.";
        }
        break;

      case "nhrcid":
        if (!value.trim()) {
          error = "NHRC ID is required.";
        } else if (value.trim().length < 3) {
          error = "NHRC ID must be at least 3 characters.";
        }
        break;

      case "collegename":
        if (!value.trim()) {
          error = "College / Organisation name is required.";
        } else if (value.trim().length < 3) {
          error = "College / Organisation name must be at least 3 characters.";
        }
        break;

      case "yearofpassout":
        if (!value.trim()) {
          error = "Year of pass out is required.";
        } else if (!/^[0-9]{4}$/.test(value.trim())) {
          error = "Enter a valid 4-digit year (e.g. 2025).";
        } else if (
          parseInt(value.trim()) < 1980 ||
          parseInt(value.trim()) > 2035
        ) {
          error = "Year must be between 1980 and 2035.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // ─── VALIDATE ALL FIELDS ──────────────────────────────────
  const validateAll = () => {
    const fields = [
      "fullName", "email", "phone", "location",
      "iama", "nhrcid", "collegename", "yearofpassout"
    ];
    const newErrors = {};
    fields.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ─── HANDLE INPUT CHANGE ──────────────────────────────────
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData({ ...formData, [name]: newValue });

    if (name !== "agree") {
      const error = validateField(name, newValue);
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  // ─── HANDLE CLEAR ─────────────────────────────────────────
  const handleReset = () => {
    setFormData({
      fullName:         "",
      email:            "",
      phone:            "",
      location:         "",
      program:          formData.program,
      iama:             "",
      nhrcid:           "",
      collegename:      "",
      yearofpassout:    "",
      companyname:      "",
      companylocation:  "",
      agree:            false,
    });
    setErrors({});
  };

  // ─── HANDLE SUBMIT ────────────────────────────────────────
  const handleSubmit = async () => {
    if (!validateAll()) {
      toast.error("Please fill all details before submitting.", { autoClose: 2000 });
      return;
    }

    const payload = {
      training_id:      selectedProgram?.id || selectedProgram?.training_id || selectedProgram?._id || null,
      full_name:        formData.fullName.trim(),
      phone:            formData.phone.trim(),
      location:         formData.location.trim(),
      iam_a:            formData.iama.trim(),
      nhrc_id:          formData.nhrcid.trim(),
      college_name:     formData.collegename.trim(),
      year_of_passout:  formData.yearofpassout.trim(),
      company_name:     formData.companyname.trim(),
      company_location: formData.companylocation.trim(),
      receive_updates:  formData.agree,
    };

    console.log("Submitting HR training registration payload:", payload);

    try {
      setLoading(true);

      const response = await ApiService.RegistrationAPI.registerForTraining(payload);
      console.log("HR training registration success:", response.data);

      toast.success(`Successfully Registered For: ${formData.program}`, {
        autoClose: 2000,
      });

      setTimeout(() => navigate("/hrdashboard/Hrlivetraining"), 2200);

    } catch (err) {
      console.error("HR training registration error:", err?.response?.data);
      console.error(
        "FULL VALIDATION DETAIL:",
        JSON.stringify(err?.response?.data?.detail, null, 2)
      );

      const status = err?.response?.status;
      const detail = err?.response?.data?.detail;

      if (status === 422 && Array.isArray(detail)) {
        detail.forEach((d, i) => {
          console.error(
            `VALIDATION ERROR #${i + 1} → field: ${d?.loc?.join(".")}, msg: ${d?.msg}`
          );
        });

        const firstError = detail[0];
        const field      = firstError?.loc?.[1] || "field";
        const msg        = firstError?.msg || "Validation error";
        toast.error(`Validation error — ${field}: ${msg}`, { autoClose: 3500 });

      } else if (status === 401) {
        toast.error("Session expired. Please login again.", { autoClose: 2500 });
        setTimeout(() => navigate("/login"), 2600);

      } else if (status === 409) {
        toast.error("You have already registered for this program!", { autoClose: 2500 });

      } else if (typeof detail === "string") {
        toast.error(detail, { autoClose: 2500 });

      } else {
        toast.error("Registration failed. Please try again.", { autoClose: 2500 });
      }

    } finally {
      setLoading(false);
    }
  };

  // ─── RENDER ───────────────────────────────────────────────
  return (
    <div className="stu-liv-app-wrapper">
      <ToastContainer position="top-center" theme="colored" />

      <div className="stu-liv-app-card">

        {/* HEADER */}
        <div className="stu-liv-app-header">
          <div>
            <h2 className="stu-liv-app-title">{selectedProgram?.title}</h2>
            <div className="stu-liv-app-badge">
              {selectedProgram?.category} • {selectedProgram?.trainer} • {selectedProgram?.eventmode} • {selectedProgram?.schedule} • {selectedProgram?.time} • {selectedProgram?.location}
            </div>
          </div>
        </div>

        <h3 className="stu-liv-app-form-title">Registration Form</h3>

        {/* FORM FIELDS */}
        <div className="stu-liv-app-grid">

          {/* Full Name */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Full Name *</label>
            <input
              className={`stu-liv-app-input ${errors.fullName ? "input-error" : ""}`}
              name="fullName"
              placeholder="Enter your full name"
              onChange={handleChange}
              value={formData.fullName}
            />
            {errors.fullName && <span className="error-text">{errors.fullName}</span>}
          </div>

          {/* Phone */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Phone Number *</label>
            <input
              className={`stu-liv-app-input ${errors.phone ? "input-error" : ""}`}
              name="phone"
              placeholder="Enter 10-digit phone number"
              maxLength={10}
              onChange={handleChange}
              value={formData.phone}
            />
            {errors.phone && <span className="error-text">{errors.phone}</span>}
          </div>

          {/* Email */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Mail *</label>
            <input
              className={`stu-liv-app-input ${errors.email ? "input-error" : ""}`}
              name="email"
              type="email"
              placeholder="Enter your email"
              onChange={handleChange}
              value={formData.email}
            />
            {errors.email && <span className="error-text">{errors.email}</span>}
          </div>

          {/* Location */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Location *</label>
            <input
              className={`stu-liv-app-input ${errors.location ? "input-error" : ""}`}
              name="location"
              placeholder="Enter your location"
              onChange={handleChange}
              value={formData.location}
            />
            {errors.location && <span className="error-text">{errors.location}</span>}
          </div>

          {/* I am a */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">I am a *</label>
            <input
              className={`stu-liv-app-input ${errors.iama ? "input-error" : ""}`}
              name="iama"
              placeholder="e.g. HR, Employee, Professional"
              onChange={handleChange}
              value={formData.iama}
            />
            {errors.iama && <span className="error-text">{errors.iama}</span>}
          </div>

          {/* NHRC ID */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">NHRC-ID *</label>
            <input
              className={`stu-liv-app-input ${errors.nhrcid ? "input-error" : ""}`}
              name="nhrcid"
              placeholder="Enter your NHRC ID"
              onChange={handleChange}
              value={formData.nhrcid}
            />
            {errors.nhrcid && <span className="error-text">{errors.nhrcid}</span>}
          </div>

          {/* College / Organisation Name — ✅ FIXED name/value binding */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">College / Organisation Name *</label>
            <input
              className={`stu-liv-app-input ${errors.collegename ? "input-error" : ""}`}
              name="collegename"
              placeholder="Enter your college / organisation name"
              onChange={handleChange}
              value={formData.collegename}
            />
            {errors.collegename && <span className="error-text">{errors.collegename}</span>}
          </div>

          {/* Year of Pass Out */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Year of Pass Out *</label>
            <input
              className={`stu-liv-app-input ${errors.yearofpassout ? "input-error" : ""}`}
              name="yearofpassout"
              placeholder="e.g. 2025"
              maxLength={4}
              onChange={handleChange}
              value={formData.yearofpassout}
            />
            {errors.yearofpassout && <span className="error-text">{errors.yearofpassout}</span>}
          </div>

          {/* Company Name — optional, from Swagger */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Company Name (Optional)</label>
            <input
              className="stu-liv-app-input"
              name="companyname"
              placeholder="Enter your company name"
              onChange={handleChange}
              value={formData.companyname}
            />
          </div>

          {/* Company Location — optional, from Swagger */}
          <div className="stu-liv-app-field">
            <label className="stu-liv-app-label">Company Location (Optional)</label>
            <input
              className="stu-liv-app-input"
              name="companylocation"
              placeholder="Enter your company location"
              onChange={handleChange}
              value={formData.companylocation}
            />
          </div>

        </div>

        {/* CHECKBOX */}
        <div className="d-flex mt-2">
          <label className="stu-liv-app-label">
            Would you like to receive updates about future events and professional opportunities? *
          </label>
          <input
            type="checkbox"
            name="agree"
            className="check-liv"
            onChange={handleChange}
            checked={formData.agree}
          />
        </div>

        {/* BUTTONS */}
        <div className="stu-liv-app-buttons">
          <button
            type="button"
            className="stu-liv-app-btn-reset"
            onClick={handleReset}
            disabled={loading}
          >
            Clear
          </button>
          <button
            type="button"
            className="stu-liv-app-btn-apply"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default Hrtrainapplication;